import { Box, Typography } from "@mui/material";
import { FLOW_HUB_ICON_CONFIG, FLOW_HUB_LAYOUT_CONFIG } from "../../../../../config/flowhub.config";
import {
  FLOW_HUB_CAROUSEL_ITEM_TITLE_SX_CONFIG,
  FLOW_HUB_CAROUSEL_ITEM_HEADER_SX_CONFIG,
  FLOW_HUB_CAROUSEL_ITEM_DESCRIPTION_SX_CONFIG,
} from "../config/flowHubCarousel.config";
import { IFlowHubCarouselItem } from "../interfaces/flowHubCarousel.interface";

export const FlowHubCarouselItem = ({ item }: { item: IFlowHubCarouselItem }) => {
  return (
    <Box
      sx={{
        ...FLOW_HUB_LAYOUT_CONFIG,
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: { xs: 2, xl: 4 },
        width: "100%",
        flex: { xs: "0 0 auto", xl: 1 },
        alignItems: "center",
        alignSelf: "center",
        minHeight: 0,
        py: { xs: 0.5, xl: 2.5 },
        px: { xs: 1.5, xl: 4 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 0,
        }}
      >
        <Box
          component="img"
          src={item.image}
          alt={item.title}
          sx={{
            maxHeight: { xs: "200px", xl: "360px" },
            minHeight: "105px",
            maxWidth: { xs: "450px", xl: "640px" },
            minWidth: 0,
            width: "100%",
            aspectRatio: "16 / 9",
            objectFit: item.imageFit || "cover",
            transform: item.imageScale ? `scale(${item.imageScale})` : "none",
            display: "block",
            margin: "0 auto", // <--- ESTO centra la imagen dentro de su contenedor
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: { xs: 1.1, xl: 1.6 },
          minHeight: 0,
        }}
      >
        <Typography sx={FLOW_HUB_CAROUSEL_ITEM_TITLE_SX_CONFIG}>{item.title}</Typography>
        <Typography sx={FLOW_HUB_CAROUSEL_ITEM_HEADER_SX_CONFIG}>{item.header}</Typography>
        <Typography sx={FLOW_HUB_CAROUSEL_ITEM_DESCRIPTION_SX_CONFIG}>{item.description}</Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 1.15, xl: 1.55 }, px: 1 }}>
          {item.list.map((listItem, index) => (
            <Box key={index} sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
              <Box sx={FLOW_HUB_ICON_CONFIG.iconPrimary}>{listItem.icon}</Box>
              <Box>
                <Typography
                  sx={{
                    ...FLOW_HUB_CAROUSEL_ITEM_HEADER_SX_CONFIG,

                    fontSize: { xs: "0.8rem", xl: "0.94rem" },
                  }}
                >
                  {listItem.title}
                </Typography>
                <Typography
                  sx={{
                    ...FLOW_HUB_CAROUSEL_ITEM_DESCRIPTION_SX_CONFIG,
                    fontSize: { xs: "0.72rem", xl: "0.86rem" },
                  }}
                >
                  {listItem.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
